import styled from '@emotion/styled';
import BaseInputLabel from '@material-ui/core/InputLabel';
import BaseNotchedOutline from '@material-ui/core/OutlinedInput/NotchedOutline';

import theme from '../../themes/default';

export const Container = styled('div')`
  position: relative;
`;

export const InputLabel = styled(BaseInputLabel)`
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(0, 24px) scale(1);
  font-size: 14px;
`;
export const Root = styled('div')`
  position: relative;
`;

export const Content = styled('div')`
  overflow-y: auto;
  height: 130px;
  margin-left: ${theme.spacing.xxSmall};
`;

export const NotchedOutline = styled(BaseNotchedOutline)`
  border-radius: ${theme.borderRadius.medium};
  border: ${(props) =>
    props.focused
      ? `2px solid ${theme.color.designSystem.purple70}`
      : `1px solid ${theme.color.grey10}`};
`;
